import { defaultTranslationArray } from '../../../../pipes/default-translation';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomTranslationPipe } from 'src/app/pipes/custom-translation.pipe';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent implements OnInit {
  isNotFound: boolean = false;
  globalLang: string = 'en-GB';
  translationsArray: any;
  content: string = 'CP_PRIVACY_TEMPLATE';
  isTranslationDone: boolean = false;
  defaultTranslationArray = defaultTranslationArray;

  constructor(private readonly _translationService: TranslationService, 
    private readonly _actRoute: ActivatedRoute, 
    private readonly languageService: LanguageService) { 
    const langId = this._actRoute.snapshot.paramMap.get('languageId');
    const userLang = navigator.language;
    if (!langId || !this.languageService.checkIsValideLanguage(langId)) {
      this.isNotFound = true;
    } else {
      this.isNotFound = false;
      this.globalLang = langId && this.languageService.checkIsValideLanguage(langId) ? langId : 
      (userLang && this.languageService.checkIsValideLanguage(userLang) ? userLang : 'en-GB');
    }
    this._translationService.sharetranslationData.subscribe((data) => {
      this.translationsArray = data;
      this.isTranslationDone = true;
    });
  }

  public checkIfIsValidLanguage(langCode:string): string {
    if(environment.supported_language.includes(langCode)){
     return langCode
    }else{
     return 'en-GB'
    }
 }

  ngOnInit(): void {
    this.content = 'CP_PRIVACY_TEMPLATE';
    if (!this.translationsArray?.length) {
      this.globalLang = this.checkIfIsValidLanguage(this.globalLang);
      this.getTranslations(this.globalLang);
    }
  }

  /**
   * @description This is done to call translations API in case of reloading screen
   * @param languageId 
   */
  public getTranslations(lang: string): void {
    this._translationService.phraseApiCallForTranslations(lang).subscribe({
      next: (translations) => {
        this.translationsArray = [...this.translationsArray, ...translations];
        this._translationService.setTranslationData(this.translationsArray);
        this._translationService.sendSelectedLanguage(this.globalLang);
        this._translationService.sendtranslationValue(this.translationsArray);
        this.isTranslationDone = true;
        this.checkForTranslatedValues();
      },
      error: () => {
        this.isTranslationDone = true;
        this.translationsArray = [...defaultTranslationArray];
      }
    });
  }

  public checkForTranslatedValues(): void {
    const langPipe = new CustomTranslationPipe();
    const transformedArray = langPipe.transform(this.content, this.translationsArray);

    if (!Array.isArray(transformedArray) || !transformedArray.length) {
      this._translationService
        .phraseApiCallForTranslations('en-GB')
        .subscribe({
          next: (translations) => {
            this.translationsArray = [...this.translationsArray, ...translations];
          },
          error: () => {
            this.isTranslationDone = true;
            this.translationsArray = [...defaultTranslationArray];
          }
        });
    }
  }

}
